/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type PayoutHistoryItemStatus = typeof PayoutHistoryItemStatus[keyof typeof PayoutHistoryItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutHistoryItemStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  RETURNED: 'RETURNED',
} as const;
